var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8724 11.4388C6.15885 11.7253 6.64583 11.7253 6.93229 11.4388L15.3542 3.01693C15.6406 2.73047 15.6406 2.24349 15.3542 1.95703L14.3229 0.925781C14.0365 0.639323 13.5781 0.639323 13.2917 0.925781L6.41667 7.80078L3.17969 4.59245C2.89323 4.30599 2.4349 4.30599 2.14844 4.59245L1.11719 5.6237C0.830729 5.91016 0.830729 6.39714 1.11719 6.68359L5.8724 11.4388Z",
    fill: "#398360"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2b3d04c4c96f5c0046a74e79275fef3f.svg";
export { ForwardRef as ReactComponent };